import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useMutation } from "@tanstack/react-query";
import dayjs from "dayjs";
import { toast } from "sonner";
import DatePickerInput from "@/components/ui/date-picker";
import { report } from "@/queries/report";

export const Route = createFileRoute("/client/daily/")({
  component: ClientDailyReport,
});

function ClientDailyReport() {
  const [date, setDate] = useState<Date | undefined>(undefined);
  const maxDate = new Date();
  const [data, setData] = useState<any>();

  maxDate.setDate(maxDate.getDate() + 1);

  const filterMutation = useMutation({
    mutationFn: () =>
      report("report_daily_balances", { wheres: { date: convertDate(date) } }),
    mutationKey: ["get", "user", "balance"],
    onSuccess(data) {
      setData(data.data.data);
    },
    onError() {
      toast.error("خطایی در دریافت گزارش رخ داده است");
    },
  });

  const convertDate = (date: any) => {
    return dayjs(date).calendar("gregory").format("YYYY-MM-DD");
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>گزارش مانده حساب</CardTitle>
        <CardDescription>
          گزارش مانده حساب خود را در یک روز بررسی کنید
        </CardDescription>
      </CardHeader>

      <CardContent>
        <div className="flex gap-1 items-end">
          <div className="flex flex-col gap-2">
            <DatePickerInput
              value={date}
              onChange={setDate}
              maxDate={new Date()}
            />
            {/* <Label>تاریخ</Label>
            <DatePicker
              locale={persian_fa}
              calendar={persian}
              maxDate={new Date()}
              onChange={(date) => {
                setDate(date)
              }}
              value={date}
              render={(value, openCalendar) => (
                <div className='relative'>
                  {value && (
                    <button
                      type='button'
                      onClick={() => {
                        setDate(null)
                      }}
                      className='absolute left-0 top-2'
                    >
                      <X />
                    </button>
                  )}
                  <Input value={value} onFocus={() => openCalendar()} className='w-full flex-1' />
                </div>
              )}
            /> */}
          </div>
          <Button
            disabled={!date}
            isLoading={filterMutation.isPending}
            onClick={() => filterMutation.mutate()}
          >
            گزارش
          </Button>
          {data && (
            <Button
              variant="outline"
              onClick={() => {
                setData(null);
                setDate(undefined);
              }}
            >
              پاک کردن
            </Button>
          )}
        </div>

        {date &&
          data &&
          (data?.length > 0 ? (
            <p className="text-lg font-bold text-center">
              حساب شما در این روز{" "}
              {Intl.NumberFormat().format(data[0].balance.split(".")[0])} ریال
              می باشد
            </p>
          ) : (
            <p>برای روز انتخاب شده اطلاعاتی وجود ندارد</p>
          ))}
      </CardContent>
    </Card>
  );
}
